import { TypedFormGroup, TypedFormControl } from '@principle-theorem/ng-shared';
import {
  IAccSoftTissue,
  AccDeglovingInjury,
} from '@principle-theorem/principle-core/interfaces';
import { AccSoftTissueInjuryFormGroup } from './acc-soft-tissue-injury.formgroup';

export class AccSoftTissueFormGroup extends TypedFormGroup<IAccSoftTissue> {
  constructor() {
    super({
      gingiva: new AccSoftTissueInjuryFormGroup(),
      mucosa: new AccSoftTissueInjuryFormGroup(),
      lip: new AccSoftTissueInjuryFormGroup(),
      deglovingInjury: new TypedFormControl<AccDeglovingInjury[]>([]),
    });
  }

  get gingiva(): AccSoftTissueInjuryFormGroup {
    return this.controls.gingiva as AccSoftTissueInjuryFormGroup;
  }

  get mucosa(): AccSoftTissueInjuryFormGroup {
    return this.controls.mucosa as AccSoftTissueInjuryFormGroup;
  }

  get lip(): AccSoftTissueInjuryFormGroup {
    return this.controls.lip as AccSoftTissueInjuryFormGroup;
  }

  get deglovingInjury(): TypedFormControl<AccDeglovingInjury[]> {
    return this.controls.deglovingInjury as TypedFormControl<
      AccDeglovingInjury[]
    >;
  }
}
